<template>
  <div
    :class="branding?.display_options?.modifier_display_style == 'grid' ? 'gridChoiceWrapper' : 'choiceWrapper'"
    @click="
      selected && choice.child_pick_list_data && !checkIfAllNestedModifiersAreNotHidden(choice)
        ? openUpsellModal(modifier, choice, 'edit')
        : openUpsellModal(modifier, choice)
    "
  >
    <div :class="branding?.display_options?.modifier_display_style == 'grid' ? 'gridChoice' : 'choice'">
      <img
        v-if="!checkIfFallbackImage(choice.image_urls.standard)"
        :class="branding?.display_options?.modifier_display_style == 'grid' ? 'gridChoiceImage' : 'choiceImage'"
        :src="choice.image_urls.standard"
        :alt="choice.itemname"
        loading="lazy"
      />
      <div :class="branding?.display_options?.modifier_display_style == 'grid' ? 'gridCheckboxRight' : 'checkboxRight'">
        <div
          :class="
            branding?.display_options?.modifier_display_style == 'grid' ? 'gridCheckboxWrapper' : 'checkboxWrapper'
          "
        >
          <div class="choiceInfo">
            <label class="checkboxLabel" :for="choice.itemid">
              {{ choice.itemname }}
            </label>
            <label v-if="choice.description != ''" class="choiceDescription" :for="choice.itemid">
              {{ choice.description }}
            </label>
            <div v-if="choice.allergen_ids || choice.class_ids" class="allergyIcons">
              <div v-for="(allergen, index) in getUniqueAllergyIcons()" :key="index" class="allergens">
                <p class="allergensNoIcon" v-if="!allergen.icon_url">{{ allergen.display }}</p>
                <img v-if="allergen.icon_url" :src="allergen.icon_url" :alt="allergen.name" class="allergen-icon" />
                <br />
                <div class="tooltip">
                  {{ allergen.name }}
                </div>
              </div>
            </div>
            <p class="choicePrice" v-if="checkIfPriceIsVisible(modifier, choice)">
              {{ choice.baseprice > 0 ? '+' : ''
              }}{{ isChoiceFree(modifier, choice) ? formatPrice(0) : (selected && choice.variants ? pizzaSidePrice : formatPrice(choice.baseprice)) }}
              <span v-if="getAllergyIcons(choice.allergen_ids)">
                <br />
              </span>
            </p>
            <p class="selectedUpsellChoices" v-if="selectedCount && selectedChildItemNames != ''">
              {{ selectedChildItemNames }}
              <br />
              <a
                v-if="!checkIfAllNestedModifiersAreNotHidden(choice)"
                href="javascript:;"
                class="editSelections"
                @click.stop="openUpsellModal(modifier, choice, 'edit')"
              >
                <p>EDIT SELECTIONS</p>
              </a>
            </p>
            <div v-if="hasRequiredNestedModifiers" class="requiredNestedWarning">
              <p>
                This choice has required selections.
                <a
                  href="javascript:;"
                  @click.stop="openUpsellModal(modifier, choice, 'edit')"
                  style="color: var(--red-color); font-family: var(--regular-bold-font)"
                >
                  Click here to select
                </a>
              </p>
            </div>
            <div
              v-if="
                choice.nutrition_matrix &&
                Object.keys(choice.nutrition_matrix).length > 1 &&
                branding?.display_options?.modifier_display_style == 'list'
              "
              class="nutritionButton"
            >
              <a @click.stop="expandNutritionInfo(choice)" href="javascript:;">
                <p>{{ checkExpandedChoices(choice) ? 'Hide' : 'Show' }} Nutrition Info</p>
              </a>
            </div>
          </div>
          <div
            :class="
              branding?.display_options?.modifier_display_style == 'grid'
                ? 'choiceButtonsWrapper'
                : 'gridChoiceButtonsWrapper'
            "
          >
            <div v-if="modifier.show_qty && selected" class="qtyWrapper">
              <button
                @click.stop="
                  multiChoiceQuantity != 1
                    ? changeChoiceQty('minus', choice, modifier)
                    : openUpsellModal(modifier, choice)
                "
              >
                <template v-if="multiChoiceQuantity != 1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 149 12">
                    <rect
                      id="Rectangle_3708"
                      :style="{ fill: branding.dark_mode_enabled ? 'var(--background-color)' : 'var(--text-color)' }"
                      data-name="Rectangle 3708"
                      width="149"
                      height="12"
                      rx="6"
                    /></svg
                ></template>
                <svg
                  v-else
                  class="delete"
                  xmlns="http://www.w3.org/2000/svg"
                  width="9.998"
                  height="10.774"
                  viewBox="0 0 9.998 10.774"
                >
                  <path
                    id="Delete_Solid"
                    d="M839.419,2646.771a.766.766,0,0,1-.767-.7l-.693-7.6c0-.025,0-.051,0-.076h-.574a.382.382,0,0,1,
                      0-.764H839.9v-.866a.769.769,0,0,1,.768-.768h2.665a.769.769,0,0,1,.768.768v.866h2.518a.382.382,0,
                      1,1,0,.764h-.574c0,.025,0,.051,0,.076l-.693,7.6a.766.766,0,0,1-.767.7Zm4.132-6.971a.379.379,0,
                      0,0-.12.257l-.229,4.186a.382.382,0,0,0,.361.4h.021a.382.382,0,0,0,.381-.361l.229-4.186a.382.382,
                      0,0,0-.36-.4h-.02a.381.381,0,0,0-.262.1Zm-1.933.278v4.186a.382.382,0,1,0,.764,0v-4.186a.382.382,
                      0,1,0-.764,0Zm-1.451-.381a.382.382,0,0,0-.36.4l.229,4.186a.382.382,0,0,0,.381.361h.021a.382.382,
                      0,0,0,.36-.4l-.229-4.186a.382.382,0,0,0-.382-.361Z"
                    transform="translate(-837.003 -2635.997)"
                    :style="{ fill: branding.dark_mode_enabled ? 'var(--background-color)' : 'var(--text-color)' }"
                  />
                </svg>
              </button>
              <p
                class="qty"
                :style="{
                  backgroundColor: branding.dark_mode_enabled ? 'var(--background-color)' : 'var(--text-color)',
                }"
              >
                {{ multiChoiceQuantity }}
              </p>
              <button @click.stop="changeChoiceQty('plus', choice, modifier)">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 149 149">
                  <path
                    id="plus"
                    d="M68.5,143V80.5H6a6,6,0,1,1,0-12H68.5V6a6,6,0,1,1,12,0V68.5H143a6,6,0,1,1,0,12H80.5V143a6,6,0,1,1-12,0Z"
                    :style="{ fill: branding.dark_mode_enabled ? 'var(--background-color)' : 'var(--text-color)' }"
                  />
                </svg>
              </button>
            </div>
            <div v-if="choice.variants && choice.variants.length > 2 && selected" class="pizzaSelections">
              <div :class="{ activeLeft: leftSelected }" @click.stop="selectSide(choice, 'Left')" class="left"></div>
              <div
                :class="{ activeWhole: wholeSelected }"
                @click.stop="selectSide(choice, 'Whole')"
                class="whole"
              ></div>
              <div
                :class="{ activeRight: rightSelected }"
                @click.stop="selectSide(choice, 'Right')"
                class="right"
              ></div>
            </div>
            <div class="selectButton">
              <div class="selectIconsWrapper">
                <svg
                  v-if="
                    !selected &&
                    !choice.child_pick_list_data &&
                    !branding?.display_options?.hide_modifier_plus_icon !== false
                  "
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    :style="{
                      fill: branding.dark_mode_enabled ? '#FFFFFF' : '#707070',
                      opacity: branding.dark_mode_enabled ? 1 : 0.35,
                    }"
                    d="M14.2012 27.5054C16.0762 27.5054 17.8389 27.1441 19.4893 26.4214C21.1494 25.7086 22.6094 24.7222 
                    23.8691 23.4625C25.1387 22.2027 26.1299 20.7476 26.8428 19.0972C27.5557 17.4371 27.9121 15.6646 
                    27.9121 13.7798C27.9121 11.9048 27.5557 10.1422 26.8428 8.49176C26.1299 6.8316 25.1387 5.37164 
                    23.8691 4.11188C22.6094 2.84235 21.1494 1.85114 19.4893 1.13824C17.8389 0.425354 16.0713 0.0689087 
                    14.1865 0.0689087C12.3115 0.0689087 10.5439 0.425354 8.88379 1.13824C7.2334 1.85114 5.77344 2.84235 
                    4.50391 4.11188C3.24414 5.37164 2.25781 6.8316 1.54492 8.49176C0.832031 10.1422 0.475586 11.9048 
                    0.475586 13.7798C0.475586 15.6646 0.832031 17.4371 1.54492 19.0972C2.26758 20.7476 3.25879 22.2027 
                    4.51855 23.4625C5.77832 24.7222 7.2334 25.7086 8.88379 26.4214C10.5439 27.1441 12.3164 27.5054 
                    14.2012 27.5054ZM14.2012 26.0552C12.502 26.0552 10.9102 25.7379 9.42578 25.1031C7.94141 24.4683 
                    6.6377 23.5894 5.51465 22.4664C4.3916 21.3433 3.5127 20.0396 2.87793 18.5552C2.25293 17.0709 
                    1.94043 15.4791 1.94043 13.7798C1.94043 12.0904 2.25293 10.5035 2.87793 9.0191C3.5127 7.53473 
                    4.3916 6.23102 5.51465 5.10797C6.6377 3.98492 7.94141 3.10602 9.42578 2.47125C10.9102 1.83649 
                    12.4971 1.5191 14.1865 1.5191C15.8857 1.5191 17.4775 1.83649 18.9619 2.47125C20.4463 3.10602 
                    21.75 3.98492 22.873 5.10797C23.9961 6.23102 24.875 7.53473 25.5098 9.0191C26.1445 10.5035 
                    26.4619 12.0904 26.4619 13.7798C26.4619 15.4791 26.1445 17.0709 25.5098 18.5552C24.875 20.0396 
                    23.9961 21.3433 22.873 22.4664C21.75 23.5894 20.4463 24.4683 18.9619 25.1031C17.4873 25.7379 
                    15.9004 26.0552 14.2012 26.0552ZM7.99023 13.7798C7.99023 13.9849 8.05859 14.1558 8.19531 
                    14.2925C8.3418 14.4293 8.51758 14.4976 8.72266 14.4976H13.4688V19.2437C13.4688 19.4488 13.5371 
                    19.6246 13.6738 19.7711C13.8105 19.9078 13.9766 19.9761 14.1719 19.9761C14.3867 19.9761 14.5625 
                    19.9078 14.6992 19.7711C14.8457 19.6343 14.9189 19.4586 14.9189 19.2437V14.4976H19.665C19.8701 
                    14.4976 20.041 14.4293 20.1777 14.2925C20.3242 14.1558 20.3975 13.9849 20.3975 13.7798C20.3975 
                    13.565 20.3291 13.3892 20.1924 13.2525C20.0557 13.106 19.8799 13.0328 19.665 13.0328H14.9189V8.30133C14.9189 
                    8.08649 14.8457 7.91071 14.6992 7.77399C14.5625 7.63727 14.3867 7.56891 14.1719 7.56891C13.9766 7.56891 
                    13.8105 7.63727 13.6738 7.77399C13.5371 7.91071 13.4688 8.08649 13.4688 8.30133V13.0328H8.72266C8.50781 
                    13.0328 8.33203 13.106 8.19531 13.2525C8.05859 13.3892 7.99023 13.565 7.99023 13.7798Z"
                  />
                </svg>
                <svg
                  class="selected"
                  v-show="selected && !modifier.show_qty"
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  xmlns="http://www.w3.org/2000/svg"
                  @click.stop="openUpsellModal(modifier, choice)"
                >
                  <path
                    d="M14.2012 27.5054C16.0762 27.5054 17.8389 27.1441 19.4893 26.4214C21.1494 25.7086 
                      22.6094 24.7222 23.8691 23.4625C25.1387 22.2027 26.1299 20.7476 26.8428 19.0972C27.5557 
                      17.4371 27.9121 15.6646 27.9121 13.7798C27.9121 11.9048 27.5557 10.1422 26.8428 
                      8.49176C26.1299 6.8316 25.1387 5.37164 23.8691 4.11188C22.6094 2.84235 21.1494 
                      1.85114 19.4893 1.13824C17.8389 0.425354 16.0713 0.0689087 14.1865 0.0689087C12.3115 
                      0.0689087 10.5439 0.425354 8.88379 1.13824C7.2334 1.85114 5.77344 2.84235 4.50391 
                      4.11188C3.24414 5.37164 2.25781 6.8316 1.54492 8.49176C0.832031 10.1422 0.475586 11.9048 
                      0.475586 13.7798C0.475586 15.6646 0.832031 17.4371 1.54492 19.0972C2.26758 20.7476 
                      3.25879 22.2027 4.51855 23.4625C5.77832 24.7222 7.2334 25.7086 8.88379 26.4214C10.5439 
                      27.1441 12.3164 27.5054 14.2012 27.5054ZM14.2012 26.0552C12.502 26.0552 10.9102 25.7379 
                      9.42578 25.1031C7.94141 24.4683 6.6377 23.5894 5.51465 22.4664C4.3916 21.3433 3.5127 
                      20.0396 2.87793 18.5552C2.25293 17.0709 1.94043 15.4791 1.94043 13.7798C1.94043 12.0904 
                      2.25293 10.5035 2.87793 9.0191C3.5127 7.53473 4.3916 6.23102 5.51465 5.10797C6.6377 
                      3.98492 7.94141 3.10602 9.42578 2.47125C10.9102 1.83649 12.4971 1.5191 14.1865 
                      1.5191C15.8857 1.5191 17.4775 1.83649 18.9619 2.47125C20.4463 3.10602 21.75 3.98492 
                      22.873 5.10797C23.9961 6.23102 24.875 7.53473 25.5098 9.0191C26.1445 10.5035 26.4619 
                      12.0904 26.4619 13.7798C26.4619 15.4791 26.1445 17.0709 25.5098 18.5552C24.875 20.0396 
                      23.9961 21.3433 22.873 22.4664C21.75 23.5894 20.4463 24.4683 18.9619 25.1031C17.4873 
                      25.7379 15.9004 26.0552 14.2012 26.0552ZM12.7217 20.3423C12.9951 20.3423 13.2246 20.2105 
                      13.4102 19.9468L20.3682 9.12164C20.417 9.03375 20.4609 8.94586 20.5 8.85797C20.5391 
                      8.76031 20.5586 8.66754 20.5586 8.57965C20.5586 8.3941 20.4854 8.23785 20.3389 
                      8.1109C20.1924 7.98395 20.0312 7.92047 19.8555 7.92047C19.6211 7.92047 19.416 8.05231 
                      19.2402 8.31598L12.6777 18.6138L9.20605 14.439C9.1084 14.3121 9.00586 14.2242 8.89844 
                      14.1754C8.80078 14.1265 8.68848 14.1021 8.56152 14.1021C8.37598 14.1021 8.21484 
                      14.1705 8.07812 14.3072C7.95117 14.4341 7.8877 14.5953 7.8877 14.7906C7.8877 14.9664 
                      7.96094 15.1519 8.10742 15.3472L11.9893 19.9468C12.0967 20.0836 12.2041 20.1861 12.3115 
                      20.2545C12.4287 20.313 12.5654 20.3423 12.7217 20.3423Z"
                    fill="#1400FF"
                  />
                </svg>
                <svg
                  v-if="!selected && choice.child_pick_list_data && !checkIfAllNestedModifiersAreNotHidden(choice)"
                  class="nestedIndicator"
                  id="chevron.right"
                  xmlns="http://www.w3.org/2000/svg"
                  width="9.551"
                  height="16.963"
                  viewBox="0 0 9.551 16.963"
                >
                  <rect id="Rectangle_3463" data-name="Rectangle 3463" width="9.551" height="16.963" opacity="0" />
                  <path
                    id="Path_19795"
                    data-name="Path 19795"
                    d="M9.551,8.477a.874.874,0,0,0-.283-.645L1.533.254A.908.908,0,0,0,.889,0,.874.874,0,0,0,0,.889a.927.927,0,0,
                        0,.254.635L7.363,8.477.254,15.43A.909.909,0,0,0,0,16.065a.874.874,0,0,0,.889.889.877.877,0,0,0,.645-.264L9.268,9.121A.89.89,0,0,0,9.551,8.477Z"
                    fill="#000000"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="checkExpandedChoices(choice)" class="nutrationInfo">
      <div v-if="choice.nutrition_matrix.serving_size != null" class="line">
        <p class="nutrionLabel">Serving Size</p>
        <p class="nutrionValue">{{ choice.nutrition_matrix.serving_size }}oz</p>
      </div>
      <div v-if="choice.nutrition_matrix.calories != null" class="line">
        <p class="nutrionLabel">Calories</p>
        <p class="nutrionValue">{{ choice.nutrition_matrix.calories }}</p>
      </div>
      <div v-if="choice.nutrition_matrix.fat != null" class="line">
        <p class="nutrionLabel">Fat</p>
        <p class="nutrionValue">{{ choice.nutrition_matrix.fat }}g</p>
      </div>
      <div v-if="choice.nutrition_matrix.fat_calories != null" class="line">
        <p class="nutrionLabel">Fat Calories</p>
        <p class="nutrionValue">{{ choice.nutrition_matrix.fat_calories }}</p>
      </div>
      <div v-if="choice.nutrition_matrix.trans_fat != null" class="line">
        <p class="nutrionLabel">Trans Fat</p>
        <p class="nutrionValue">{{ choice.nutrition_matrix.trans_fat }}g</p>
      </div>
      <div v-if="choice.nutrition_matrix.saturated_fat != null" class="line">
        <p class="nutrionLabel">Saturated Fat</p>
        <p class="nutrionValue">{{ choice.nutrition_matrix.saturated_fat }}g</p>
      </div>
      <div v-if="choice.nutrition_matrix.cholesterol != null" class="line">
        <p class="nutrionLabel">Cholesterol</p>
        <p class="nutrionValue">{{ choice.nutrition_matrix.cholesterol }}mg</p>
      </div>
      <div v-if="choice.nutrition_matrix.sodium != null" class="line">
        <p class="nutrionLabel">Sodium</p>
        <p class="nutrionValue">{{ choice.nutrition_matrix.sodium }}mg</p>
      </div>
      <div v-if="choice.nutrition_matrix.carbs != null" class="line">
        <p class="nutrionLabel">Carbs</p>
        <p class="nutrionValue">{{ choice.nutrition_matrix.carbs }}g</p>
      </div>
      <div v-if="choice.nutrition_matrix.fiber != null" class="line">
        <p class="nutrionLabel">Fiber</p>
        <p class="nutrionValue">{{ choice.nutrition_matrix.fiber }}g</p>
      </div>
      <div v-if="choice.nutrition_matrix.sugars != null" class="line">
        <p class="nutrionLabel">Sugars</p>
        <p class="nutrionValue">{{ choice.nutrition_matrix.sugars }}g</p>
      </div>
      <div v-if="choice.nutrition_matrix.protein != null" class="line">
        <p class="nutrionLabel">Protein</p>
        <p class="nutrionValue">{{ choice.nutrition_matrix.protein }}g</p>
      </div>
    </div>
  </div>
</template>

<script>
import choiceMixins from '@/mixins/choiceMixins.js'
import formattingMixins from '@/mixins/formattingMixins'
import { mapState } from 'vuex'
import allergensMixins from '@/mixins/allergensMixins'

export default {
  data() {
    return {
      openNutritionChoicesIds: [],
    }
  },
  props: [
    'choice',
    'modifier',
    'checkIfFallbackImage',
    'selected',
    'selectedCount',
    'selectedChildItemNames',
    'leftSelected',
    'rightSelected',
    'wholeSelected',
    'pizzaSidePrice',
    'multiChoiceQuantity',
    'hasRequiredNestedModifiers',
  ],
  computed: {
    ...mapState(['storeConfig', 'branding']),
  },
  mixins: [choiceMixins, formattingMixins, allergensMixins],
  methods: {
    openUpsellModal(modifier, choice, mode) {
      this.$emit('openUpsellModal', modifier, choice, mode)
    },
    selectSide(choice, side) {
      this.$emit('selectSide', choice, side)
    },
    changeChoiceQty(type, choice, modifier) {
      this.$emit('changeChoiceQty', type, choice, modifier)
    },
    checkIfAllNestedModifiersAreNotHidden(choice) {
      // go thorugh modifiers in choice.child_pick_list_data.pick_lists and return true if every modifier is with display_style == hidden
      let allNestedModifiersAreHidden = true
      allNestedModifiersAreHidden = choice.child_pick_list_data.pick_lists.every((modifier) => {
        return modifier.display_style === 'hidden'
      })
      return allNestedModifiersAreHidden
    },
    getUniqueAllergyIcons() {
      const uniqueAllergenIds = [...new Set(this.choice.allergen_ids)]
      const uniqueClassIds = [...new Set(this.choice.class_ids)]
      return this.getAllergyIcons(uniqueAllergenIds, uniqueClassIds)
    },
  },
}
</script>

<style src="../../../assets/css/Modals/ItemModals/ChoiceCell.css" scoped></style>
